import { render, staticRenderFns } from "./SocialContact.vue?vue&type=template&id=09f9932e&"
import script from "./SocialContact.vue?vue&type=script&lang=js&"
export * from "./SocialContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports